import { get } from "lodash";
const mspMarketType = 20;

export const getChildOrgs = (orgListToFilter, orgIdToFilter) => {
  return orgListToFilter.filter(
    (obj) => obj.parentId === orgIdToFilter && obj.market === mspMarketType
  );
};

// given a user obj, returns array of orgRoles
export const getOrgRoles = (user) => {
  const orgRolesToReturn = get(user, ["orgRoles"], []);
  return orgRolesToReturn;
};

export const getShouldDisplayDataRetentionMessage = (
  newLicenseValue,
  orgModel
) => {
  const existingLicenseValue = get(orgModel, ["config", "license"], "FREE");

  if (existingLicenseValue === "ADVANCED") {
    if (newLicenseValue === "M365") return true;
    if (newLicenseValue === "FREE") return true;
  }

  if (existingLicenseValue === "CLOUD") {
    if (newLicenseValue === "M365") return true;
    if (newLicenseValue === "FREE") return true;
  }

  if (existingLicenseValue === "M365") {
    if (newLicenseValue === "FREE") return true;
  }

  return false;
};
